import React from 'react';
import { Button, Column } from '@smartplatform/ui';
import { ModelTable } from 'root/admin/components';
import store from '../../store';

const SubscriptionList = ({ rootPath, path }) => {
	const sendToSubscribers = async () => {
		await store.model.Subscription.sendToSubscribers();
	};
	return (
		<div>
			<h3> Подписанные пользователи </h3>
			{/* временная кнопка */}
			<div style={{ margin: '10px 0' }}>
				<Button className="btn-primary" onClick={sendToSubscribers}>
					Разослать почту
				</Button>
			</div>

			<ModelTable model="Subscription" rootPath={rootPath} path={path}>
				<Column property="name" label="Электронная почта" />
				<Column property="news" label="Новости" />
				<Column property="direct-speech" label="Прямая речь" />
				<Column property="video" label="Видео" />
				<Column property="photo" label="Фото" />
				<Column property="createdAt" label="Дата создания" />
			</ModelTable>
		</div>
	);
};

export default SubscriptionList;
